<template>
    <div class="col-sm-12">
        <template v-if="actions.length > 0">
            <div v-for="(action, index) in actions" class="card-text" :data-testid="'visit-action-' + action.id">
                <div class="d-flex justify-content-between border border-light" :class="(action.limit_contravention !== null ? 'bg-danger-light':'')">
                    <div class="p-0 text-secondary" v-if="action.internal">
                        {{ action.operation.code }} <i title="interní výkon" class="fa fa-hand-spock-o text-danger" aria-hidden="true"></i> {{ action.operation.name }}
                    </div>
                    <div class="p-0" v-else="">
                        <template v-if="action.limit_contravention !== null">
                            <button title="porušení pravidel vykazování" type="button" id="contraventionActionButton" @click="showModalActionContravention(action.limit_contravention)" class="btn btn-sm btn-outline-danger mr-sm-2">
                                <i class="fa fa-exclamation-circle"></i>
                            </button>
                        </template>
                        {{ action.operation.code }} - {{ action.operation.name }}
                        <span class="text-primary"><i class="fa fa-diamond" aria-hidden="true"></i>
                            {{ action.operation.point_total }}
                        </span>
                        <button type="button" id="infoActionButton" @click="showModalOperationInfo(action.operation)" class="btn btn-sm btn-outline-primary mr-sm-2" :data-testid="'visit-action-info-' + action.id"><i class="fa fa-info-circle"></i></button>

                        <button class="btn btn-sm btn-outline-danger" v-if="action.operation.zulp === true && openedAddZulpActionId === action.id" @click="openCloseAddZulpActionId(action.id)" :data-testid="'visit-zulp-toggle-' + action.id"><i class="fa fa-minus"></i> ZULP</button>
                        <button class="btn btn-sm btn-outline-success" v-if="action.operation.zulp === true && openedAddZulpActionId !== action.id" @click="openCloseAddZulpActionId(action.id)" :data-testid="'visit-zulp-toggle-' + action.id"><i class="fa fa-plus"></i> ZULP</button>
                        <button class="btn btn-sm btn-outline-danger" v-if="action.operation.zum === true && openedAddZumActionId === action.id" @click="openCloseAddZumActionId(action.id)" :data-testid="'visit-zum-toggle-' + action.id"><i class="fa fa-minus"></i> ZUM</button>
                        <button class="btn btn-sm btn-outline-success" v-if="action.operation.zum === true && openedAddZumActionId !== action.id" @click="openCloseAddZumActionId(action.id)" :data-testid="'visit-zum-toggle-' + action.id"><i class="fa fa-plus"></i> ZUM</button>
                    </div>
                    <div class="p-0">
                        <i>{{ action.note }}</i>
                    </div>
                    <div class="p-0">
                        <template v-if="action.zulp.length < 1 && action.zum.length < 1">
                            <button v-if="!actionsPending" @click="actionsPending ? null : removeAction(action.id)" class="btn btn-sm btn-outline-danger" :data-testid="'visit-action-delete-' + action.id"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                            <button class="btn btn-sm btn-outline-danger disabled" v-else><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                        </template>
                    </div>
                </div>
                <list-zulp v-on:update="updateDiagnosis" :zulp="action.zulp"></list-zulp>
                <template v-if="action.id === openedAddZulpActionId">
                    <add-zulp v-on:update="updateDiagnosis" :action-id="action.id"></add-zulp>
                </template>
                <list-zum v-on:update="updateDiagnosis" :zum="action.zum"></list-zum>
                <template v-if="action.id === openedAddZumActionId">
                    <add-zum v-on:update="updateDiagnosis" :operation="action.operation.code" :action-id="action.id"></add-zum>
                </template>
            </div>
        </template>
        <action-contravention :limit-contravention="limitContravention"></action-contravention>
    </div>
</template>

<script>
  import AddZulp from './AddZulp.vue'
  import ListZulp from './ListZulp.vue'
  import AddZum from './AddZum.vue'
  import ListZum from './ListZum.vue'
  import ActionContravention from '@/views/Visit/modals/ActionContravention.vue'

  export default {
    data () {
      return {
        waitForResponse: false,
        // actions: [],
        actionsReload: '',
        actionsPending: false,
        openedAddZulpActionId: false,
        openedAddZumActionId: false,
        // action contravention modal
        limitContravention: false
      }
    },
    props: ['doUpdate', 'diagnosisId', 'actions'],
    methods: {
      updateDiagnosis () {
        this.$emit('update')
      },
      removeAction (id) {
        this.waitForResponse = true
        this.$http.delete('action/' + id).then(response => {
          this.$emit('update')
        }, response => {
          // error.processError(response.status, response.body)
        })
      },
      openCloseAddZulpActionId (actionId) {
        if (this.openedAddZulpActionId === actionId) {
          this.openedAddZulpActionId = false
        } else {
          this.openedAddZulpActionId = actionId
        }
      },
      openCloseAddZumActionId (actionId) {
        if (this.openedAddZumActionId === actionId) {
          this.openedAddZumActionId = false
        } else {
          this.openedAddZumActionId = actionId
        }
      },
      showModalOperationInfo (operation) {
        this.$emit('openOperationModal', operation)
      },
      showModalActionContravention (limitContravention) {
        this.limitContravention = limitContravention
        this.$modal.show('action-contravention')
      }
      /* ,
      showModal (name) {
        this.$modal.show(name)
      },
      showModalOperationInfo (open, operation) {
        this.$emit(operation)
        this.modalOperationInfoOpened = true
        this.showModal('operation-info')
      } */
    },
    watch: {
      //
    },
    beforeMount () {
      //
    },
    components: {
      // ClientVisits,
      AddZulp,
      ListZulp,
      AddZum,
      ListZum,
      ActionContravention
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Visit/components/ListActions.vue?4158d1e0